export default class PasswordToggle {
    /**
     * Create the PasswordToggle instance.
     * @param rootElement Wrapper element containing the password input and toggle button.
     */
    constructor(rootElement) {
        this.root = rootElement;
        if (this.root.classList.contains('password-toggle-initialized')) {
            return;
        }
        this.toggleButton = this.root.querySelector('[data-password-toggle]');
        this.showIcon = this.root.querySelector('.toggle-show');
        this.hideIcon = this.root.querySelector('.toggle-hide');
        this.passwordInput = null;
        if (this.toggleButton) {
            const targetId = this.toggleButton.getAttribute('data-password-toggle');
            this.passwordInput = targetId ? document.getElementById(targetId) : null;
        }
        this.init();
        this.root.classList.add('password-toggle-initialized');
    }
    /**
     * Initialize event listeners.
     */
    init() {
        if (!this.toggleButton || !this.passwordInput) {
            return;
        }
        this.toggleButton.addEventListener('click', (event) => this.onToggleClick(event));
    }
    /**
     * Handle toggle button clicks and switch password visibility.
     * @param event Click event.
     */
    onToggleClick(event) {
        event.preventDefault();
        if (!this.passwordInput || !this.showIcon || !this.hideIcon) {
            return;
        }
        if (this.passwordInput.type === 'password') {
            this.showPassword();
        }
        else {
            this.hidePassword();
        }
    }
    /**
     * Show the password as plain text.
     */
    showPassword() {
        if (!this.passwordInput || !this.showIcon || !this.hideIcon) {
            return;
        }
        this.passwordInput.type = 'text';
        this.showIcon.classList.add('hidden');
        this.hideIcon.classList.remove('hidden');
    }
    /**
     * Hide the password.
     */
    hidePassword() {
        if (!this.passwordInput || !this.showIcon || !this.hideIcon) {
            return;
        }
        this.passwordInput.type = 'password';
        this.showIcon.classList.remove('hidden');
        this.hideIcon.classList.add('hidden');
    }
}
